import { render, staticRenderFns } from "./RestaurantManagementPanel.vue?vue&type=template&id=3c7c9436&"
import script from "./RestaurantManagementPanel.vue?vue&type=script&lang=js&"
export * from "./RestaurantManagementPanel.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantManagementPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RestaurantManagementPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
